import {FontSizeOutlined, MenuOutlined, SettingOutlined,} from '@ant-design/icons'
import {Avatar, Button, Drawer, Radio, Result, Spin} from 'antd'
import {article_getById_Api, poll_get_Api, post_getPostbyId_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import {articleSchema, askSchema, pollSchema, postSchema} from 'apis/schema'
import classnames from 'classnames'
import classNames from 'classnames'
import {Keywords} from 'components/Feed/BaseEmbed'
import Count from 'components/Feed/Count'
import Description from 'components/Feed/Description'
import FeedContext from 'components/Feed/FeedContext'
import {FeedProvider} from 'components/Feed/FeedProvider'
import {Message} from 'components/Feed/Message'
import {Share} from 'components/Feed/Share'
import {allActions, DetailAsk, DetailFeed} from 'components/Feed/TimeLineFeed'
import Timestamp from 'components/Feed/Timestamp'
import {Vote} from 'components/Feed/Vote'
import {ChannelIcon} from 'components/icons/ChannelIcon'
import ContentLayout from 'components/layouts/Default/ContentLayout'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import {NullAsDefault, renderElse} from "views/Shared";
import {SelectEntityItem} from 'components/SelectEntityItem'
import SeparatedDot from 'components/SeparatedDot'
import Toggle from 'components/Toggle'
import {WithDetailPopup} from 'components/WithDetailPopup'
import {callNativeShare, createFacebookShareLink, createTwitterShareLink,} from 'helpers'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import getUpperFirstChar from 'helpers/getUpperFirstChar'
import preventParentEvent from 'helpers/preventParentEvent'
import _ from 'lodash'
import {createAsyncAction} from 'modules/asyncCache'
import useAsync from 'modules/asyncCache/useAsync'
import useTranslate from 'modules/local/useTranslate'
import useRouter, {useHistory} from 'modules/navigation/useRouter'
import React, {useEffect, useState} from 'react'
import {FaBookmark, FaRegBookmark} from 'react-icons/fa'
import {RiFacebookFill, RiShareForwardFill, RiTwitterXLine,} from 'react-icons/ri'
import {useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {branch, compose, mapProps} from 'recompose'
import {selectEntities} from 'redux/selectors'
import {staticPaths} from 'routes/staticPaths'
import LoadingPage from 'views/LoadingPage'
import {SlateRenderer} from 'views/SlateEditor'
import {convertFromString} from 'views/SlateEditor/functions'
import {ask_getById_Api} from '../../apis/ask'
import {paths} from '../MainPage/contains'
import {Cate} from '../NewFeed/Cate'
import {HorizontalList} from '../NewFeed/HorizontalList'
import {HeaderButton} from '../Organization/components/PageHeader'
import TableOfContents from '../SlateEditor/Editors/TableOfContents'
import './Feed.css'
import {FeedMoreRecommends} from './FeedMoreRecommends'
import {Responses} from './Responses'
import {renderIf} from "../Shared";
import {getAbsoluteLinkToDetail} from "../../helpers/getLinkToDetail";
import {ProductAdsContainer} from "../AppLocals/Shop/components/ProductAds";
import FlyWrapper from "../AppLocals/Templates/FlyWrapper";
import {headerHeight} from "../AppLocals/configs";
import OrganizationAnnouncementPageContent from "./components/OrganizationAnnouncementPageContent";
import CourseClassAnnouncementPageContent from "./components/CourseClassAnnouncementPageContent";

export const FeedContentTypes = Object.freeze({
    ALL: 'all',
    POST: 'post',
    REPOST: 'repost',
    ARTICLE: 'article',
    CHANNEL: 'channel',
    POLL: 'poll_question',
    ASK: 'ask',
})

export const FeedActionTypes = Object.freeze({
    ADS: 'advertise',
    WOG: 'wog',
    STICKY: 'sticky',
})

export const isValidContentType = (type, excluded = [FeedContentTypes.ALL]) =>
    !_.isEmpty(type) && !excluded.includes(type)

export const feedContentTypes = [
    {
        label: 'all',
        value: FeedContentTypes.ALL,
        getTotal: ({
                       total_asks = 0,
                       total_polls = 0,
                       total_posts = 0,
                       total_articles = 0,
                   }) =>
            Number(
                _.defaultTo(total_asks, 0) +
                _.defaultTo(total_polls, 0) +
                _.defaultTo(total_posts, 0) +
                _.defaultTo(total_articles, 0)
            ),
    },
    {
        label: 'articles',
        value: FeedContentTypes.ARTICLE,
        getTotal: ({total_articles}) => Number(_.defaultTo(total_articles, 0)),
    },
    {
        label: 'news',
        value: FeedContentTypes.POST || FeedContentTypes.REPOST,
        getTotal: ({total_posts}) => Number(_.defaultTo(total_posts, 0)),
    },
    {
        label: 'q-and-a',
        value: FeedContentTypes.ASK,
        getTotal: ({total_asks}) => Number(_.defaultTo(total_asks, 0)),
    },
    {
        label: 'poll',
        value: FeedContentTypes.POLL,
        getTotal: ({total_polls}) => Number(_.defaultTo(total_polls, 0)),
    },
].map(({value, ...item}) => ({...item, value, name: value}))

export const fromFeedContentTypes = (type) => {
    return feedContentTypes.find((item) => type === _.get(item, 'value'))
}

const Article = ({id}) => {
    const t = useTranslate()
    const {handleGoBack, history} = useRouter()

    const [editorState, setEditorState] = useState()
    const [textSize, setTextSize] = useState('default')
    const item = useSelector(
        (state) =>
            selectEntities(state, id, articleSchema) ||
            _.find(_.values(_.get(state, 'entities.articles')), {idname: id})
    )
    useEffect(() => {
        if (item) {
            setEditorState(convertFromString(item?.content))
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item && item.update])

    const {isLoading, success, errorMessages, ...rest} = useAsync({
        apiInfo: article_getById_Api,
        query: {
            ':article_id': id,
        },
    })
    return (
        <ContentLayout
            title={t('articles')}
            renderMenu={NullAsDefault}
            extra={
                item && (
                    <>
                        {item.edit && (
                            <HeaderButton onClick={() => history.push(`/article/${id}/edit`)}>
                                <SettingOutlined
                                    style={{
                                        fontSize: '1.4em',
                                    }}
                                />
                            </HeaderButton>
                        )}
                        <div className="flex mr-2">
                            <HeaderButton
                                component="a"
                                href={createFacebookShareLink(getAbsoluteLinkToDetail(item))}
                                target="_blank"
                                width={22}
                                height={22}
                                icon={<RiFacebookFill size={12}/>}
                            />
                            <HeaderButton
                                component="a"
                                href={createTwitterShareLink(getAbsoluteLinkToDetail(item))}
                                target="_blank"
                                width={22}
                                height={22}
                                icon={<RiTwitterXLine size={10}/>}
                            />
                            <HeaderButton
                                onClick={() => {
                                    callNativeShare({
                                        title: getTitle(item),
                                        url: getAbsoluteLinkToDetail(item),
                                    })
                                }}
                                width={22}
                                height={22}
                                icon={<RiShareForwardFill size={12}/>}
                            />
                        </div>
                    </>
                )
            }
            right={
                <div className="flex flex-col gap-6">
                    <ProductAdsContainer keyword={_.get(item, 'keywords', []).map(k => k.keyword).join(', ')}/>
                    {item && (
                        <div className="flex flex-col gap-6 mx-3 mt-6">
                            {!_.isEmpty(_.get(item, 'others_in_container')) && (
                                <div
                                    className="w-full px-3 py-2 flex flex-col border-l-3 border-color-300 rounded-lg shadow-block">
                                    <div className="mb-2 pb-1 border-b border-color-300 flex items-center gap-2">
                                        <span
                                            className="flex-1 font-semibold text-sm text-color-100 leading-tight tracking-widest">
                                            {t('related articles')}
                                        </span>
                                    </div>
                                    <FeedMoreRecommends
                                        item={item.container}
                                        list={item.others_in_container}
                                    />
                                </div>
                            )}
                            {!_.isEmpty(_.get(item, 'others_in_creator')) && (
                                <div
                                    className="w-full px-3 py-2 flex flex-col border-l-3 border-color-300 rounded-lg shadow-block">
                                    <div className="mb-2 pb-1 border-b border-color-300 flex items-center gap-2">
                                        <span
                                            className="flex-1 font-semibold text-sm text-color-100 leading-tight tracking-widest">
                                            {t('from the sender')}
                                        </span>
                                    </div>
                                    <FeedMoreRecommends
                                        item={item.creator}
                                        list={item.others_in_creator}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </div>
            }
            onCancel={handleGoBack}>
            <Spin spinning={isLoading}>
                {success && item && (editorState || null) && (
                    <article>
                        <div
                            onContextMenu={
                                item.content_disabled ? preventParentEvent : undefined
                            }
                            className={classnames(
                                'flex mx-auto w-full',
                                item.content_disabled && 'content_disabled'
                            )}>
                            <div className="w-full">
                                <div className="px-3 relative">
                                    <div className="verticalList">
                                        <div
                                            className="inline-flex p-1 pt-3 border-b w-full truncate items-center justify-start text-color-300 flex">
                                            <div
                                                style={{
                                                    marginRight: '1rem',
                                                    fontSize: '2rem',
                                                }}
                                                className="flex-shrink-0">
                                                <ChannelIcon
                                                    premium={_.get(item, 'container.premium', 0)}
                                                    className="mr-2 text-color-100 text-3xl w-8 h-8"
                                                />
                                            </div>
                                            <div className="flex-1">
                                                <Link
                                                    to={getLinkToDetail(_.get(item, 'container'))}
                                                    className="font-bold cursor-pointer">
                                                    {_.get(item, 'container.title') ||
                                                    _.get(item, 'container.name')}
                                                </Link>
                                                <div className="font-normal text-xs">
                                                    {_.get(item, 'container.owner.title') ||
                                                    _.get(item, 'container.owner.name')}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex">
                                            <HorizontalList
                                                className="flex-1 pr-2"
                                                renderMore={NullAsDefault}
                                                list={item.categories}
                                                renderItem={(cate) => (
                                                    <Link
                                                        to={
                                                            paths.categoryPath
                                                                .replace(':category', cate.id)
                                                        }>
                                                        {' '}
                                                        <Cate item={cate}/>
                                                    </Link>
                                                )}
                                            />
                                            <Toggle>
                                                {(isToggle, toggle) => (
                                                    <>
                                                        <div className="background p-1">
                                                            <div
                                                                style={{
                                                                    top: 'var(--header-visible-height)',
                                                                }}
                                                                className="sticky flex items-center">
                                                                <div className="py-3 font-bold">
                                                                    <Radio.Group
                                                                        defaultValue={textSize}
                                                                        size="middle"
                                                                        onChange={(e) =>
                                                                            setTextSize(e.target.value)
                                                                        }>
                                                                        <Radio.Button value="default">
                                                                            <FontSizeOutlined className="text-xs"/>
                                                                        </Radio.Button>
                                                                        <Radio.Button value="large">
                                                                            <FontSizeOutlined className="text-lg"/>
                                                                        </Radio.Button>
                                                                    </Radio.Group>
                                                                </div>

                                                                <HeaderButton onClick={() => toggle()}>
                                                                    <MenuOutlined/>
                                                                </HeaderButton>
                                                            </div>
                                                        </div>
                                                        {isToggle && (
                                                            <Drawer
                                                                title={t('table of contents')}
                                                                open="true"
                                                                onClose={() => toggle()}>
                                                                <TableOfContents editorState={editorState}/>
                                                            </Drawer>
                                                        )}
                                                    </>
                                                )}
                                            </Toggle>
                                        </div>
                                    </div>
                                </div>
                                <div style={{fontSize: textSize === 'default' ? '1em' : '1.2em'}}>
                                    <h1 style={{fontSize: '2em'}} className="px-3 pt-3 font-bold leading-tight">
                                        {item.title}
                                    </h1>
                                    <div className="px-3 text-color-300 text-sm">
                                        <SeparatedDot/>
                                        <Timestamp
                                            className="font-normal"
                                            timestamp={_.get(item, 'created')}
                                        />
                                        {!!item.total_views && (
                                            <>
                                                <SeparatedDot/>
                                                <span className="font-bold">
                                                    {item.total_views}{' '}
                                                </span>
                                                {t('views')}
                                            </>
                                        )}
                                    </div>
                                    <WithDetailPopup
                                        item={item.owner}
                                        style={{
                                            textOverflow: 'ellipsis',
                                        }}>
                                        <div className="flex items-center px-3 py-1">
                                            <Avatar
                                                style={{marginRight: '1em',}}
                                                size="small"
                                                shape="circle"
                                                src={_.get(item, 'owner.thumbnail')}>
                                                {getUpperFirstChar(getTitle(item.owner))}
                                            </Avatar>
                                            <div className="truncate flex-1 flex flex-col">
                                                <span className="font-semibold ">
                                                    {_.get(item, 'owner.name') || _.get(item, 'owner.title')}
                                                </span>
                                            </div>
                                        </div>
                                    </WithDetailPopup>
                                    {item.description && (
                                        <div className="p-3 ">
                                            <Description
                                                type={'article'}
                                                mentions={item && item.mentions}>
                                                {item.description}
                                            </Description>
                                        </div>
                                    )}
                                    <div className="p-3 w-full verticalList mx-auto ">
                                        <SlateRenderer value={editorState}/>
                                        <Keywords keywords={_.get(item, 'keywords', [])}/>
                                    </div>
                                </div>
                                <SelectEntityItem
                                    item={item.id}
                                    schema={articleSchema}>
                                    {(item) => (
                                        <FeedProvider
                                            item={item}
                                            defaultActions={allActions}>
                                            <FeedContext.Consumer>
                                                {({handleClick, shareUrl}) => (
                                                    <div
                                                        className="sticky bottom-0 z-20 p-2 flex items-center background">
                                                        <Vote/>
                                                        <Message/>
                                                        <Share url={shareUrl}/>
                                                        <Count
                                                            active={item.bookmark_status}
                                                            onClick={
                                                                !item.bookmark_status
                                                                    ? () => handleClick('bookmark')
                                                                    : () => handleClick('unbookmark')
                                                            }
                                                            key="bookmark"
                                                            color={
                                                                item.bookmark_status
                                                                    ? 'text-yellow-500'
                                                                    : 'text-color-300'
                                                            }
                                                            component={
                                                                item.bookmark_status
                                                                    ? FaBookmark
                                                                    : FaRegBookmark
                                                            }
                                                        />
                                                    </div>
                                                )}
                                            </FeedContext.Consumer>
                                        </FeedProvider>
                                    )}
                                </SelectEntityItem>
                            </div>
                        </div>
                        <div className="background-100">
                            <div className="py-4 mx-auto mt-6 w-full verticalList p-3 flex flex-col">
                                <h2 className="font-bold ">{t('responses')}</h2>
                                <Responses
                                    type={getType(item)}
                                    id={getId(item)}
                                />
                            </div>
                        </div>
                        <LayoutContext.Consumer>
                            {({breakpoint}) =>
                                ['xs', 'sm', 'md'].find((value) => value === breakpoint) ? item && (
                                    <>
                                        {!_.isEmpty(item.others_in_container) && (
                                            <>
                                                {!_.isEmpty(item.others_in_container) && (
                                                    <div
                                                        className="w-full px-3 py-2 flex flex-col border-l-3 border-color-300 rounded-lg shadow-block">
                                                        <div
                                                            className="mb-2 pb-1 border-b border-color-300 flex items-center gap-2">
                                                            <span
                                                                className="flex-1 font-semibold text-sm text-color-100 leading-tight tracking-widest">
                                                                {t('related articles')}
                                                            </span>
                                                        </div>
                                                        <FeedMoreRecommends
                                                            item={item.container}
                                                            list={item.others_in_container}
                                                        />
                                                    </div>
                                                )}
                                                {!_.isEmpty(item.others_in_creator) && (
                                                    <div
                                                        className="w-full px-3 py-2 flex flex-col border-l-3 border-color-300 rounded-lg shadow-block">
                                                        <div
                                                            className="mb-2 pb-1 border-b border-color-300 flex items-center gap-2">
                                                            <span
                                                                className="flex-1 font-semibold text-sm text-color-100 leading-tight tracking-widest">
                                                                {t('from the sender')}
                                                            </span>
                                                        </div>
                                                        <FeedMoreRecommends
                                                            item={item.creator}
                                                            list={item.others_in_creator}
                                                        />
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        <ProductAdsContainer
                                            keyword={_.get(item, 'keywords', []).map(k => k.keyword).join(', ')}/>
                                    </>
                                ): null
                            }
                        </LayoutContext.Consumer>
                    </article>
                )}
                {errorMessages && (
                    <Result
                        status="404"
                        subTitle={errorMessages['error']}
                        extra={
                            <Link to={staticPaths.home}>
                                <Button
                                    type="primary"
                                    className="rounded-lg no-shadow no-text-shadow">
                                    {t('Back Home')}
                                </Button>
                            </Link>
                        }
                    />
                )}
            </Spin>
        </ContentLayout>
    )
}

export default compose(
    mapProps((props) => ({
        id: _.get(props, 'match.params.id'),
        key: _.get(props, 'match.params.id'),
        type: _.get(props, 'match.params.type'),
    })),

    branch(
        ({type}) => type === 'article',
        () => Article
    ),
    branch(
        ({type}) => type === 'o-announcement',
        () => OrganizationAnnouncementPageContent
    ),
    branch(
        ({type}) => type === 'c-announcement',
        () => CourseClassAnnouncementPageContent
    )
)(({id, type}) => {
    const history = useHistory()
    const t = useTranslate()
    const item = useSelector((state) => {
        let schema = postSchema
        switch (type) {
            case 'poll_question':
                schema = pollSchema
                break
            case 'article':
                schema = articleSchema
                break
            case 'ask':
                schema = askSchema
                break
            default:
                schema = postSchema
                break
        }
        return selectEntities(state, id, schema)
    })

    const {isDeleted} = item ?? {}

    useEffect(() => {
        if (isDeleted) {
            history.goBack()
        }
    }, [isDeleted])

    const {handleGoBack} = useRouter()
    const {isLoading, errorMessages, ...rest} = useAsync(
        type === 'ask'
            ? createAsyncAction({
                apiInfo: ask_getById_Api,
                query: {
                    ':ask_id': id,
                },
            })
            : type === 'poll_question'
            ? createAsyncAction({
                apiInfo: poll_get_Api,
                query: {
                    ':poll_question_id': id,
                },
            })
            : type === 'article'
                ? createAsyncAction({
                    apiInfo: article_getById_Api,
                    query: {
                        ':article_id': id,
                    },
                })
                : createAsyncAction({
                    apiInfo: post_getPostbyId_Api,
                    query: {
                        ':post_id': id,
                    },
                })
    )

    const isAsk = type === 'ask'

    return (
        <ContentLayout
            title={t(type)}
            renderMenu={NullAsDefault}
            onCancel={handleGoBack}
            extra={item && type === 'post' && (
                <div className="flex gap-2 mr-2">
                    <HeaderButton
                        component="a"
                        href={createFacebookShareLink(getAbsoluteLinkToDetail(item))}
                        target="_blank"
                        width={22}
                        height={22}
                        icon={<RiFacebookFill size={12}/>}
                    />
                    <HeaderButton
                        component="a"
                        href={createTwitterShareLink(getAbsoluteLinkToDetail(item))}
                        target="_blank"
                        width={22}
                        height={22}
                        icon={<RiTwitterXLine size={10}/>}
                    />
                    <HeaderButton
                        onClick={() => {
                            callNativeShare({
                                title: getTitle(item),
                                url: getAbsoluteLinkToDetail(item),
                            })
                        }}
                        width={22}
                        height={22}
                        icon={<RiShareForwardFill size={12}/>}
                    />
                </div>
            )}
            right={NullAsDefault}
            renderRight={NullAsDefault}>
            <div className="w-full mt-0 md:mt-2 max-w-6xl mx-auto flex flex-col lg:flex-row gap-3 md:gap-6 px-0 py-0 md:px-3 md:py-3">
                {renderElse(
                    isDeleted,
                    <div className="flex flex-col flex-1 gap-3 mb-10 p-3 pt-2 background shadow-md rounded-xl content-feed-detail">
                        <div key={item?.id} className="w-full flex flex-col flex-1">
                            {item ? (
                                <>
                                    <div className={classNames("Feed verticalList", isAsk && 'content-ask-view')}>
                                        {isAsk ? (
                                            <DetailAsk detail={true} item={item}/>
                                        ) : (
                                            <DetailFeed detail={true} item={item}/>
                                        )}
                                    </div>
                                    {!isAsk && (
                                        <Responses type={getType(item)} id={getId(item)}/>
                                    )}
                                </>
                            ) : <LoadingPage/>}
                        </div>
                        <LayoutContext.Consumer>
                            {({breakpoint}) =>
                                ['xs', 'sm', 'md'].find((value) => value === breakpoint) ? (
                                    <div className="mb-10 flex flex-col gap-6">
                                        <div className="flex flex-col background shadow-block rounded-xl">
                                            {renderIf(
                                                !_.isEmpty(item?.others_in_container),
                                                <div className="p-4 flex flex-col gap-2">
                                                    <span className="font-semibold text-slate-500 leading-tight underline tracking-widest">
                                                        {t('related articles')}:
                                                    </span>
                                                    <FeedMoreRecommends
                                                        item={item?.container}
                                                        list={item?.others_in_container}
                                                    />
                                                </div>
                                            )}
                                            {(!_.isEmpty(item?.others_in_container) && !_.isEmpty(item?.others_in_creator))  && <div className="border-b border-color-100"/>}
                                            {renderIf(
                                                !_.isEmpty(item?.others_in_creator),
                                                <div className="p-4 flex flex-col gap-2">
                                                    <span className="font-semibold text-slate-500 leading-tight underline tracking-widest">
                                                        {t('from the sender')}:
                                                    </span>
                                                    <FeedMoreRecommends
                                                        item={item?.creator}
                                                        list={item?.others_in_creator}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        <ProductAdsContainer
                                            keyword={_.get(item, 'keywords', []).map(k => k.keyword).join(', ')}/>
                                    </div>
                                ) : null
                            }
                        </LayoutContext.Consumer>
                    </div>
                )}
                <LayoutContext.Consumer>
                    {({isLg}) => (
                        isLg && (
                            <div className="ant-col-7 space-y-6 right-block">
                                <FlyWrapper top={parseInt(headerHeight)} className="mt-0 FlyWrapper">
                                    <div className="flex flex-col space-y-6">
                                        {(!_.isEmpty(item?.others_in_container) || !_.isEmpty(item?.others_in_creator)) && (
                                            <div className="flex flex-col background shadow-block rounded-xl">
                                                {!_.isEmpty(item?.others_in_container) && (
                                                    <div className="p-4 flex flex-col gap-2">
                                                        <span className="font-semibold text-slate-500 leading-tight underline tracking-widest">
                                                            {t('related articles')}:
                                                        </span>
                                                        <FeedMoreRecommends
                                                            item={item.container}
                                                            list={item?.others_in_container}
                                                        />
                                                    </div>
                                                )}
                                                {(!_.isEmpty(item?.others_in_container) && !_.isEmpty(item?.others_in_creator)) && <div className="border-b border-color-100"/>}

                                                {!_.isEmpty(item?.others_in_creator) && (
                                                    <div className="p-4 flex flex-col gap-2">
                                                        <span className="font-semibold text-slate-500 leading-tight underline tracking-widest">
                                                            {t('from the sender')}:
                                                        </span>
                                                        <FeedMoreRecommends
                                                            item={item.creator}
                                                            list={item?.others_in_creator}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        <ProductAdsContainer
                                            keyword={_.get(item, 'keywords', []).map(k => k.keyword).join(', ')}/>
                                        <div className="h-16"/>
                                    </div>
                                </FlyWrapper>
                            </div>
                        )
                    )}
                </LayoutContext.Consumer>
            </div>
        </ContentLayout>
    )
})
